<template>
  <div class="main-product">
    <div class="product-img" :class="{ error: error }">
      <img
        v-if="!error"
        class="cover-img d-block"
        :class="{ 'cover-img-sold-out': product.soldOut || product.offline }"
        :src="product.imagePath"
        @error="error = true"
      />
    </div>
    <div class="section product-info mb-2">
      <div v-if="product.paymentRestrict == 1 && isE7g" class="point-label">
        <span class="points">
          <img src="@/assets/img/icon/pi-point.svg" />
        </span>
        P幣全額折抵
      </div>
      <div class="product-title">{{ product.title }}</div>
      <div
        v-if="product.subTitle"
        class="sub-title"
        v-html="product.subTitle"
      ></div>
      <div v-show="isGroupCoupon">
        <div class="group-ticket">成套票券</div>
      </div>
      <div class="buy-section">
        <div class="left-item">
          <div
            v-if="
              product.originalPrice && product.originalPrice != product.price
            "
            class="item original-price"
          >
            ${{ product.originalPrice }}
          </div>
          <div
            v-if="product.paymentRestrict == 1"
            class="item price"
            :class="{ 'price-sold-out': product.soldOut || product.offline }"
          >
            <span class="points">
              <img src="@/assets/img/icon/pi-point.svg" />
            </span>
            {{ product.price }}
          </div>
          <div
            v-else
            class="item price"
            :class="{ 'price-sold-out': product.soldOut || product.offline }"
          >
            ${{ product.price }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="content.remark != null" class="section remark">
      <div class="remark">
        <div class="notice">小編摘要</div>
        <div v-html="content.remark" class="content"></div>
      </div>
    </div>
    <div class="section tabs">
      <div class="nav-tabs">
        <div
          v-for="(tab, index) in tabList"
          :key="'tab' + index"
          class="nav-item"
          :class="{ active: tabIndex == tab }"
          @click="tabIndex = tab"
        >
          {{ tab }}
        </div>
      </div>
      <div class="tab-content">
        <div v-if="tabIndex == '詳細介紹'" class="tab-pane fade">
          <div id="detailDesc" class="dealItem">
            <div class="description" v-html="content.description" />
          </div>
        </div>
        <div v-if="tabIndex == '店家資訊'" class="tab-pane fade">
          <div class="dealItem">
            <div
              v-for="(si, idx) in content.storeInfo"
              :key="idx"
              class="overHeight shopAddress_wrap"
            >
              <!--↓↓↓↓↓系統後台↓↓↓↓↓-->
              <div id="AddressTitle">{{ si.name }}</div>
              <div id="Addressinner">
                <ul>
                  <li>電話: {{ si.tel }}</li>
                  <li>
                    地址: {{ si.address }}
                    <a
                      v-if="si.mapLink != null && si.mapLink != ''"
                      :href="si.mapLink"
                      class="btn_map btn_color"
                    >
                      Map
                    </a>
                  </li>
                  <li v-if="si.open != null && si.open != ''">{{ si.open }}</li>
                  <li v-if="si.memo != null && si.memo != ''">{{ si.memo }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tabIndex == '權益說明'" class="tab-pane fade">
          <div class="dealItem">
            <div class="restriction" v-html="content.restriction"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainProduct',
  components: {},
  props: {
    product: Object,
    content: Object,
    isGroupCoupon: Boolean,
  },
  data: function() {
    return {
      tabIndex: 0,
      error: false,
      isE7g: false,
    }
  },
  computed: {
    storeInfoVisible() {
      return (
        this.content != null &&
        this.content.storeInfo != null &&
        this.content.storeInfo.length > 0
      )
    },
    tabList() {
      if (this.content != null) {
        const tabList = []
        if (
          this.content.description &&
          this.content.description != '<div></div>'
        ) {
          tabList.push('詳細介紹')
        }
        if (this.storeInfoVisible) {
          tabList.push('店家資訊')
        }
        if (
          this.content.restriction &&
          this.content.restriction != '<div></div>'
        ) {
          tabList.push('權益說明')
        }
        return tabList
      } else {
        return []
      }
    },
  },
  watch: {
    tabList() {
      if (this.tabList.length) {
        this.tabIndex = this.tabList[0]
      }
    },
  },
  mounted: function() {
    if (localStorage.getItem('source') === 'e7g') {
      this.isE7g = true
    }
  },
}
</script>

<style scoped lang="scss">
.group-ticket {
  display: inline-block;
  min-width: 66px;
  border-radius: 8px;
  background-color: #fff6e0;
  color: #ff8c00;
  font-size: 12px;
  padding: 2px 8px;
}
.product-img {
  width: 100%;
  // max-height: 100vw;
  overflow: hidden;
  &.error {
    min-height: 100vw;
    background: url('../../assets/img/placholder_512.svg');
    background-size: contain;
    background-repeat: no-repeat;
  }
}

.description >>> img {
  width: 100% !important;
  height: auto !important;
}

.description {
  iframe,
  object,
  table {
    width: 100% !important;
    height: auto !important;
  }
}

.main-product {
  font-family: 'SF Pro Display', 'Roboto', 'Ping Fang TC', 'Ping Fang TC', Arial,
    Helvetica, sans-serif;
  display: block;

  .cover-img {
    object-fit: cover;
    object-position: center;
    width: 100%;
  }
  .product-title {
    font-size: 18px;
    font-weight: bold;
    color: #383838;
    display: block;
    margin: 10px 0;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .sub-title {
    font-size: 14px;
    color: #545454;
    padding: 0 0 10px;
    line-height: 24px;
    text-align: left;
  }
  .buy-section {
    display: flex;
    justify-content: space-between;
  }
  .buy-section .left-item .price {
    font-family: 'SF Pro Display', 'Roboto', 'Ping Fang TC', 'Ping Fang TC',
      Arial, Helvetica, sans-serif;
    font-size: 24px;
    color: #1da7fc;
    font-weight: bold;
    display: inline-block;
    margin-left: 6px;
    .points {
      display: inline-block;
      vertical-align: middle;
      margin-right: -5px;
      width: 23px;
      img {
        width: 100%;
      }
    }
  }
  .buy-section .left-item .original-price {
    font-family: 'SF Pro Display', 'Roboto', 'Ping Fang TC', 'Ping Fang TC',
      Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: lighter;
    color: #9b9b9b;
    display: inline-block;
    text-decoration: line-through;
    vertical-align: text-bottom;
  }

  .cover-img-sold-out {
    filter: grayscale(1) opacity(0.5);
  }

  .btn-buy-sold-out {
    background-color: #cccccc !important;
  }

  .price-sold-out {
    color: #9b9b9b !important;
  }

  .section {
    width: 100%;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    text-align: left;
    &.product-info {
      padding: 0 4.8% 20px;
      .point-label {
        margin-top: 10px;
        padding: 2.5px 0;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        border-radius: 13px;
        background-color: #1da7fc;
        .points {
          display: inline-block;
          width: 15px;
          height: 16px;
          margin: 2px 4px 2px 0;
          object-fit: contain;
          vertical-align: top;
          margin-right: -2px;
          img {
            width: 100%;
          }
        }
      }
    }
    &.remark {
      padding: 20px 4.8%;
    }
  }
  .section-top-margin {
    margin-top: 1rem;
  }
  .section .remark {
    // padding: 0rem 1rem 1rem 1rem;
    box-sizing: border-box;
  }
  .section .remark .notice {
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: #383838;
  }
  .section .remark .content {
    font-size: 14px;
    color: #4a4a4a;
    box-sizing: border-box;
    width: 100%;
    display: block;
    li {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .content {
    padding-top: 10px;
  }
  .description,
  .restriction,
  .content {
    ::v-deep * {
      // width: auto !important;
      max-width: 100%;
    }
  }

  .section .nav-tabs {
    background-color: #edf0f2;
    border-radius: 20px;
    width: 100%;
    display: flex;
  }
  .section.tabs {
    padding: 0 16px;
  }
  .section .nav-item {
    flex-grow: 1;
    text-align: center;
    padding: 3px 0;
    font-size: 16px;
    font-weight: normal;
    color: #383838;
    border: 1px solid transparent;
  }

  .section .nav-item.active {
    flex-grow: 1;
    text-align: center;
    padding: 3px 0;
    background-color: #ffffff;
    border-radius: 20px;
    border: 1px solid #ddd;
  }
  .section .tab-content .tab-pane {
    padding: 20px 0;
    font-size: 0.8rem;
    line-height: 1.4rem;
  }
  .section .tab-content p {
    padding: 0px;
    margin: 0px;
  }
  .section .tab-content img {
    width: 100% !important;
  }
  .section .tab-content h5 {
    font-size: 1.5rem;
    color: #999;
    line-height: 2rem;
    border-left: 4px solid #999;
    padding-left: 4px;
    margin: 10px 0;
  }

  .section .tab-content .explain_label_wrap {
    margin-bottom: 0.6rem;
    line-height: 1.4rem;
    font-size: 0.8rem;
    display: flex;
    flex-wrap: wrap;
  }

  .section .tab-content .explain_label_wrap span.explain_label {
    border: 1px solid #bf0000;
    font-size: 0.8rem;
    padding: 0.3rem;
    color: #bf0000;
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .section .tab-content #AddressTitle {
    font-size: 1rem;
    color: #bf0000;
    line-height: 1.5rem;
  }
  .section .shopAddress_wrap {
    margin-top: 0.5rem;
  }
}
</style>
